import { useFormik } from "formik";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  requestResetPassword,
  resetPasswordViaOtp,
} from "../../../services/AuthServices";
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
import { Message } from "primereact/message";
import { homePagePath } from "../../../constant";
import * as Yup from "yup";

import LOGO from "../../assets/thurent-logo.svg";
import "./Login.css";
import { Button } from "primereact/button";
import { Divider } from "primereact/divider";
import { detectAndSaveUserCountry } from "../../../util/geoUtils";

function ThurentForgotPassword() {
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [otpSent, setOtpSent] = useState(false);
  const [countryCode, setcountryCode] = useState("+91")
  const [selectedCountry, setSelectedCountry] = useState('in');
  const [phoneValue, setPhoneValue] = useState('');
  const navigate = useNavigate();

  React.useEffect(() => {
    // Force location detection on page mount (no permission popup)
    const initLocation = async () => {
      const countryData = await detectAndSaveUserCountry();
      if (countryData && countryData.lowerIsoCode) {
        setSelectedCountry(countryData.lowerIsoCode);
        setcountryCode(countryData.countryCode);
        formik.setFieldValue('countryCode', countryData.countryCode);
      }
    };
    initLocation();
  }, []);
  const formik = useFormik({
    initialValues: {
      identifier: "",
      otp: "",
      newPassword: "",
      confirmPassword: "",
      countryCode: "",
    },
    validationSchema: Yup.object({
      identifier: Yup.string()
        .required("Mobile number is required")
        .matches(/^[0-9]{10}$/, "Enter a valid 10-digit mobile number"),
      otp: otpSent
        ? Yup.string()
          .length(6, "OTP must be exactly 6 digits")
          .required("OTP is required")
        : null,
      newPassword: otpSent
        ? Yup.string()
          .min(8, "Password must be at least 8 characters")
          .required("New password is required")
        : null,
      confirmPassword: otpSent
        ? Yup.string()
          .oneOf([Yup.ref("newPassword"), null], "Passwords must match")
          .required("Please confirm your new password")
        : null,
    }),
    onSubmit: async (values) => {
      setLoading(true);
      try {
        if (!otpSent) {
          const responseMessage = await requestResetPassword(values.identifier, values.countryCode);
          setMessage(responseMessage);
          setOtpSent(true);
        } else {
          // Handle OTP verification and password reset
          const responseMessage = await resetPasswordViaOtp({
            identifier: values.identifier,
            otpCode: values.otp,
            newPassword: values.newPassword,
            countryCode: values.countryCode
          });
          setMessage(responseMessage);
          setTimeout(() => {
            navigate("/login");
          }, 2000);
        }
      } catch (err) {
        setMessage(err.message);
      } finally {
        setLoading(false);
      }
    },
  });

  return (
    <div className="th-auth">
      <div className="th-auth__container">
        <img
          src={LOGO}
          alt="thurent"
          className="th-auth__logo"
          onClick={() => {
            navigate(homePagePath);
          }}
        />
        {message &&
          (message.includes("successfully") ? (
            <Message
              severity="success"
              className="font-inter mb-3"
              text={message}
              style={{ width: "100%", marginBottom: "5px" }}
            />
          ) : (
            <Message
              severity="error"
              text={message}
              style={{ width: "100%", marginBottom: "5px" }}
            />
          ))}
        <form onSubmit={formik.handleSubmit}>
          <div className="mb-3">
            <PhoneInput
              country={selectedCountry}
              onlyCountries={['in', 'us']}
              disableCountryCode={true}
              disableDropdown={true}
              value={phoneValue}
              onChange={(value, data) => {
                // Store the full value (with dial code) in local state so PhoneInput
                // is correctly controlled and doesn't re-parse on re-render.
                setPhoneValue(value);

                const dialCode = data.dialCode;       // e.g., "91"
                const newCountryCode = `+${dialCode}`;
                setcountryCode(newCountryCode);

                // react-phone-input-2 with disableCountryCode={true} still prepends
                // the dial code internally to `value`. Strip it exactly once.
                const nationalNumber = value.startsWith(dialCode)
                  ? value.slice(dialCode.length)
                  : value;

                // Cap at 10 digits for the national number stored in formik
                const cleanedValue = nationalNumber.slice(0, 10);

                formik.setFieldValue('countryCode', newCountryCode);
                formik.setFieldValue('identifier', cleanedValue);
                setSelectedCountry(data.countryCode);
              }}
              placeholder="Enter mobile number"
              inputProps={{
                name: 'mobileNumber',
                required: true,
                onBlur: formik.handleBlur,
                disabled: otpSent, // Disable input after OTP is sent
              }}
              containerClass="phone-container"
              inputClass="phone-input"
              buttonClass="phone-flag-button"
            />

            {formik.errors.identifier && formik.touched.identifier && (
              <p className="error">{formik.errors.identifier}</p>
            )}
          </div>

          {otpSent && (
            <>
              <div className="mb-3">
                <input
                  type="text"
                  name="otp"
                  placeholder="Enter 6-digit OTP"
                  value={formik.values.otp}
                  onChange={formik.handleChange}
                  maxLength="6" // Limit OTP input to 6 digits
                  className="th-login__input"
                />
                {formik.errors.otp && formik.touched.otp && (
                  <p className="error">{formik.errors.otp}</p>
                )}
              </div>

              <div className="mb-3">
                <input
                  type="password"
                  name="newPassword"
                  placeholder="Enter new password"
                  value={formik.values.newPassword}
                  onChange={formik.handleChange}
                  className="th-login__input"
                />
                {formik.errors.newPassword && formik.touched.newPassword && (
                  <p className="error">{formik.errors.newPassword}</p>
                )}
              </div>

              <div className="mb-3">
                <input
                  type="password"
                  name="confirmPassword"
                  placeholder="Confirm new password"
                  value={formik.values.confirmPassword}
                  onChange={formik.handleChange}
                  className="th-login__input"
                />
                {formik.errors.confirmPassword &&
                  formik.touched.confirmPassword && (
                    <p className="error">{formik.errors.confirmPassword}</p>
                  )}
              </div>
            </>
          )}

          <button
            type="submit"
            className="th-login__button font-inter"
            disabled={loading}
          >
            {loading
              ? otpSent
                ? "Verifying OTP..."
                : "Sending OTP..."
              : otpSent
                ? "Reset Password"
                : "Send OTP"}
          </button>
        </form>

        <Divider className="font-inter th-divider">OR</Divider>

        <button
          className="th-login__button font-inter font-normal"
          onClick={() => navigate("/login")}
        >
          Existing User? LOGIN
        </button>

        <button
          className="th-signup__button font-inter font-normal"
          onClick={() => navigate("/signup")}
        >
          New User? SIGNUP
        </button>

        <div className="flex w-full justify-content-center align-items-center mt-3">
          <Button
            label="Back to Home"
            icon="pi pi-home"
            className="th-backtohome__button"
            iconPos="right"
            severity="contrast"
            onClick={() => navigate(homePagePath)}
            size="small"
          />
        </div>
      </div>
    </div>
  );
}

export default ThurentForgotPassword;
